import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $processing, $done } from 'services/activity/action';

export const MODULE = 'Routing';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;
export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $get = ActionCreator.Async(MODULE, 'Get', (id, payload) => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/tms/routing/${id}`, payload)
      .then((response) => {
        dispatch($get.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $manifest = ActionCreator.Async(
  MODULE,
  'Get.Manifest',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($processing($manifest.OPERATION));

      return await Rest.GET(`${API_URL}/tms/routing/${id}/manifest`, payload)
        .then((response) => {
          dispatch($manifest.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($manifest.OPERATION)));
    };
  }
);
